<ul>
  <ng-container *ngIf="node$ | async as node">
    <ng-container *ngFor="let child of node?.children">
      <li *ngFor="let link of child.children">
        <ng-container *ngIf="isExternalUrl(link.url); else internalLink">
          <cx-generic-link [url]="link.url" [target]="link.target" [title]="link.title">{{ link.title }}</cx-generic-link>
        </ng-container>
        <ng-template #internalLink>
          <cx-generic-link [title]="link.title" (click)="openModal(link)">{{ link.title }}</cx-generic-link>
        </ng-template>
      </li>
    </ng-container>
  </ng-container>
</ul>
